module.exports = __webpack_public_path__ + "img/contract_bg.6d61ac4c.jpg";